import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import moment from 'moment'
import { useDispatch, useSelector } from "react-redux";
import {fetchStateDashboardExcal} from '../../store/actions/stateDashboard'
import { Link } from 'react-router-dom';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import RecordKeeper   from "../RecordKeeper/loads/RecordKeeper";
import {fetchLoads} from '../../store/actions/loads'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Doughnut,Line} from 'react-chartjs-2';
import axios from '../../http-config';
// import axios from 'axios';
// import axios from 
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
   //height: '100%',
    // maxHeight: "41vh",
    // overflow: "hidden"
  },
  containerMobile:{
    marginTop:'0px'
  },
  header:{
    zIndex:'0 !important'
  }
});

export default function StickyHeadTable(props) {
const dispatch = useDispatch();
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [sortOrder,setSortOrder] = React.useState('')
  const [currentSortId,setCurrentSortId] = React.useState('')
  const [openChart, setOpenChart] = React.useState(false)
  const [chartDash, setChartDash] = React.useState([])
  // let line_chart_labels = []
  let columnsData = []
  let rowsData    = []
  
  function createData(ULB, Area, Count) {
    return {ULB, Area, Count };
  }

  const rows  = props.rows.map(row => {
      return {
        ...row,
        // lastUpdated : moment(row.lastUpdated).format('DD-MM-YYYY')
      }
  
  });
  
  let columns = props.columns
  columns = window.innerWidth <=480 ? props.columns.slice(1) : props.columns
  
  const fixedColumns = props.columns.slice(0,1)
  // const rows    = props.rows


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
const handleExcalDownload =()=>{
  dispatch(fetchStateDashboardExcal(props.payloadDExcal))
}

  const handleSort = (e,col) => {
    let sortBy
    if (currentSortId === col.id) {
      sortBy = (sortOrder === 'DESC') ? 'ASC' : 'DESC';
    } 
    else {
      sortBy = 'DESC';    
    }
    setSortOrder(sortBy)
    setCurrentSortId(col.id)
    props.handleSort(e,col,sortBy)
  }
  const handleOpenChart =(id)=>{
    setOpenChart(true)
const url = `/?interval=${props.payloadDExcal.interval}&ulbId=${id}`;
if(id){
  axios({
    method: 'get',
    url: '/dashboard'+url,
    headers: {'Authorization': `Bearer ${props.payloadDExcal.token}`}
})
.then((response) => {
  setChartDash(response.data.data)
}).catch(error => {

})
}

  }

 const handleFreqClose = () => {
    setOpenChart(false)
  };
let datevalue = props.payloadDExcal
let dashboard_data =!!chartDash&& chartDash.dashboard_data
let colors = []
let values = []
let pie_chart_labels = []
let line_chart_labels = []
let line_chart_data   = []
// let rows = []
let TableDataBody = []
let columnsDataHeaders = []
if(dashboard_data){
dashboard_data[0].date_wise_loads.forEach(function(date_wise_load) {
  line_chart_labels.push(date_wise_load.DateTime)
  line_chart_data.push(date_wise_load.Count)
});
}



let minTick         = Math.min(...line_chart_data) - (Math.max(...line_chart_data)*0.1) < 0 ? 0 : Math.round(Math.min(...line_chart_data) - (Math.max(...line_chart_data)*0.1))
let maxTick         = Math.ceil(Math.max(...line_chart_data) + (Math.max(...line_chart_data)*0.1))
const tickDifference  = Math.ceil(maxTick/10)
maxTick = Math.max(...line_chart_data) + tickDifference
minTick = Math.min(...line_chart_data) - tickDifference < 0 ? 0 : Math.round(Math.min(...line_chart_data) - tickDifference)






var lineChartOptions = {
  showScale: true,
  //pointDot: true,
  //showLines: false,
  title: {
    display: true,
    text: 'Day Wise Loads'
},
  legend: {
    display: true,
    labels: {
      boxWidth: 50,
      fontSize: 12,
      fontColor: 'rgb(115 115 115)',
      padding: 5,
    }
  },
  scales: {
    yAxes: [{
      ticks: {
        //beginAtZero:true,
        autoSkip: true,
        min: minTick,
        maxTicksLimit: tickDifference,
        max: maxTick
      },
      scaleLabel: {
        boxWidth: 50,
        fontSize: 12,
        fontColor: '#3DAB35',
        padding: 10,
        display: true,
        labelString: 'No of Loads',
        fontStyle: "bold",
      }
    }],
    xAxes: [{
      scaleLabel: {
        boxWidth: 50,
        fontSize: 12,
        fontColor: '#3DAB35',
        padding: 10,
        display: true,
        labelString: 'Days',
        fontStyle: "bold",

      }
    }]
  }

}

const lineData =  {
  labels: line_chart_labels,
  datasets: [
    {
      color:"#3DAB35",
      label:"Collected Loads",
      fill: false,
      lineTension: 0.1,
      borderColor:  "#3DAB35",
      pointRadius: 5,
      pointBorderColor: "#3DAB35",
      pointBackgroundColor: "#3DAB35",
      data: line_chart_data,
    }  
  ]
};
  return (
    <div className="dashboard_new_listing">
  
    <Paper className={classes.root}>
    <Grid container spacing={3} direction="row">
        <Grid item xs={12} align="right">
          <Button onClick={handleExcalDownload} variant="outlined" style={{color:"#3DAB35",marginTop:'10px',marginBottom: '10px',marginRight: '10px',postion:'fixed',display:'block'}}>Download Excel</Button>
        </Grid>
      </Grid>
       {window.innerWidth <=480 ?
       <Grid container spacing={0} direction="row">
       <Grid items xs={6} style={{paddingLeft:'5px'}}>
          <TableContainer className={classes.containerMobile}>
            <Table stickyHeader aria-label="sticky table" style={{ tableLayout: 'fixed' }}>
              <TableHead>
              <TableRow>
              {fixedColumns && fixedColumns.length > 0 && fixedColumns.map((column) => {
               return (
                <TableCell 
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontWeight:'bolder', fontSize:"12px"}}
                    className={classes.header}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'start',
                        whiteSpace: 'break-spaces',
                        height:'3em',
                        marginLeft: '-10px',
                        }}>
                    <div onClick={(e) => handleSort(e,column,sortOrder)}>
                    <div>{
                        currentSortId === column.id? sortOrder ==='ASC'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                    }
                    </div>   
                  </div>{column.label == "Utilization Rate In" ? <div>Utilization Rate In %</div>: column.label}
                  </div>
                </TableCell>
              )}
              )}
            </TableRow>
            </TableHead>
            <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,rowIndex) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                  {fixedColumns && fixedColumns.length > 0 && fixedColumns.map((column,index) => {
                    const value = row[column.id];
                    if(column.id ==="ulbName"){
                      var oneValue =  row[column.id];
                      var ulbId = row.ULBId
                     return <TableCell style={{whiteSpace: "normal", wordWrap: "break-word" ,fontSize:"12px"}} className={"white-space"}><Link to={{pathname:`/records/${ulbId}`, startDate:datevalue.startDate, endDate:datevalue.endDate }}  style={{textDecoration:'none' ,color:'#3DAB35'}}>{oneValue}</Link></TableCell>
                    }

                    if(column.id ==="action"){
                      var ulbChartId = row.ULBId
                      return <TableCell><Button style={{color:'white', backgroundColor:'#3DAB35'}} onClick={()=>handleOpenChart(ulbChartId)}>View Chart </Button> </TableCell>
                    }
                    return (
                      <TableCell key={index} align={column.align} style={{whiteSpace: "normal", wordWrap: "break-word" ,fontSize:"12px"}} className={"white-space"}>
                         {value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
          </Table>
        </TableContainer>                        
        </Grid>
        <Grid item xs={6} style={{paddingRight:'5px'}}>
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => {
               return (
                <TableCell 
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontWeight:'bolder', fontSize:"12px"}}
                    className={classes.header}>
                   <div style={{
                        display: 'flex',
                        alignItems: 'start',
                        whiteSpace: 'break-spaces',
                        height:'3em',
                        marginLeft: '-10px',
                        width: "150px"
                        }}>
                    <div onClick={(e) => handleSort(e,column,sortOrder)}>
                    <div>{
                        currentSortId === column.id? sortOrder ==='ASC'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                    }
                    </div>   
                  </div>{column.label == "Utilization Rate In" ? <div>Utilization Rate In %</div>: column.label}
                  </div>
                </TableCell>
              )}
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,rowIndex) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                  {columns.map((column,index) => {
                    const value = row[column.id];
                    if(column.id ==="ulbName"){
                      var oneValue =  row[column.id];
                      var ulbId = row.ULBId
                     return <TableCell><Link to={{pathname:`/records/${ulbId}`, startDate:datevalue.startDate, endDate:datevalue.endDate }}  style={{textDecoration:'none' ,color:'#3DAB35'}}>{oneValue}</Link></TableCell>
                    }
                    if(column.id ==="action"){
                      var ulbChartId = row.ULBId
                      return <TableCell><Button style={{color:'white', backgroundColor:'#3DAB35'}} onClick={()=>handleOpenChart(ulbChartId)}>View Chart </Button> </TableCell>
                    }
                    return (
                      <TableCell key={index} align={column.align} style={{whiteSpace: "normal", wordWrap: "break-word" ,fontSize:"12px"}} className={"white-space"}>
                         {value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
        </Grid>
      </Grid> : 
        <Grid container spacing={3} direction="row">
        <Grid item xs={12} lg={12}>
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => {
               return (
                <TableCell 
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth, fontWeight:'bolder', fontSize:"12px"}}
                    className={classes.header}>
                   <div style={{
                        display: 'flex',
                        alignItems: 'start',
                        whiteSpace: 'break-spaces',
                        height:'3em',
                        marginLeft: '-10px',
                        width: "150px"
                        }}>
                    <div onClick={(e) => handleSort(e,column,sortOrder)}>
                    <div>{
                        currentSortId === column.id? sortOrder ==='ASC'?(<ArrowDropDownIcon fontSize="small"/>):(<ArrowDropUpIcon fontSize="small"/>) :(<ArrowDropDownIcon fontSize="small"/>)
                    }
                    </div>   
                  </div>{column.label == "Utilization Rate In" ? <div>Utilization Rate In %</div>: column.label}
                  </div>
                </TableCell>
              )}
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row,rowIndex) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                  {columns.map((column,index) => {
                    const value = row[column.id];
                    if(column.id ==="ulbName"){
                      var oneValue =  row[column.id];
                      var ulbId = row.ULBId
                     return <TableCell><Link to={{pathname:`/records/${ulbId}`, startDate:datevalue.startDate, endDate:datevalue.endDate }}  style={{textDecoration:'none' ,color:'#3DAB35'}}>{oneValue}</Link></TableCell>
                    }
                    if(column.id ==="action"){
                      var ulbChartId = row.ULBId
                      return <TableCell><Button style={{color:'white', backgroundColor:'#3DAB35'}} onClick={()=>handleOpenChart(ulbChartId)}>View Chart </Button> </TableCell>
                    }
                    return (
                      <TableCell key={index} align={column.align} style={{whiteSpace: "normal", wordWrap: "break-word" ,fontSize:"12px"}} className={"white-space"}>
                         {value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
        </Grid>
      </Grid>
      
        }
      
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
















    <div className="setFreq">
      <Dialog
        maxWidth={'md'}
        fullWidth={true} 
        open={true}
        open={openChart}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle className="text-center border-none " style={{color:'#3dab35'}}><span style={{fontSize:'18px'}}>History</span></DialogTitle>
        <DialogContent > 
            <div className="create_ulb_content_outer">
                <div className="create_ulb_content_sched">
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                       {/* <h1>hii</h1> */}
                        <Paper height={500}><hr style={{border: "1px solid #3DAB35", marginLeft:"5%", width:"30px"}}></hr><Line data={lineData} options = {lineChartOptions} width={800} height={300}/></Paper>  
                        </Grid>

                     
                    </Grid>
                </div>
            </div>      
        </DialogContent>
        <DialogActions className="leftp">
            <Button autoFocus onClick={handleFreqClose} style={{
                background:'none',
                color:'#3dab35',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }} 
                type="submit">Cancel
            </Button>
            {/* <Button onClick={this.handleFreqSubmit} style={{
                background:'#3dab35',
                color:'white',
                border:" 1px solid rgba(61, 171, 53, 0.5)",
                }}  autoFocus
                type="submit"
                disabled={this.state.LastDesludgedDate!=null&& this.state.selecedFreq == 'daily'?false:this.state.LastDesludgedDate!=null&& this.state.selecedFreq == 'alternate' ? false: this.state.freqDisableStatus}
                >Save
            </Button> */}
        </DialogActions>
    </Dialog>
    </div>
    </div>
  );
}
